import MAddOnPurchaseProductList from "../../components/mobile/activity/MAddOnPurchaseProductList";
import { ADD_ON_PURCHASE_TYPE } from "../../components/activity/add-on-purchase/types";
import { ADD_ON_PURCHASE_MESSAGES } from "../../components/activity/add-on-purchase/messages";
import { useAddOnPurchaseRequest } from "../../components/activity/add-on-purchase/useAddOnPurchaseRequest";
import React, { useState, useContext, useRef, useEffect } from "react";
import { Button, Space, Drawer, message } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  activityBundleListUrl,
  activityCategoryUrl,
  activityDetailUrl,
  activityProductsUrl,
} from "Utils/constant";
import { AppContext } from "Store";
import activityIcon from "Images/mobile/activity.svg";
import exchangeIcon from "Images/mobile/exchange.svg";
import activeActivityIcon from "Images/mobile/activeActivity.svg";
import activeExchangeIcon from "Images/mobile/activeExchange.svg";
import delIcon from "Images/mobile/×.svg";
import searchIcon from "Images/mobile/msearch.svg";
import MHeader from "Components/mobile/common/MHeader";
import MFooter from "Components/mobile/common/MFooter";
import MProductCard from "Components/mobile/activity/MProductCard";
import Loading from "Components/common/Loading";
import {
  formatDate,
  getAAId,
  getAuthToken,
  isMobile,
} from "Utils/common";
import { getInitialSelectedAddressKey, getSelectedSTObj } from "Utils/addressUtils";
import axios from "axios";

import { getUniqueness, pageDetailsDataPush, subSearchDataPush } from "Utils/analyticsUtils";
import Exceptions from "Components/activity/Exceptions";
import LoadingMore from "Components/common/LoadingMore";
import { getFilteredCategories } from "Utils/activityHelper";
import { getCartCount } from "Utils/apiUtils";
import { logOperation } from "Utils/operationLogUtils";
import MBundleList from "Components/mobile/activity/MBundleList";
import { Bundle } from "src/types/global";
import RichTextContent from "Components/RichTextContent";
import { buildActivityCartCache } from "Utils/richTextS3ImageUtil";

const MActivity: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const loadMoreNode = useRef(null);
  const [filterDrawer, setFilterDrawer] = useState(false);
  const [loadReady, setLoadReady] = useState<boolean>(false);
  const [hasNextPage, setHasNextPage] = useState<boolean>(false);
  const { activityId } = useParams<{ activityId: string }>();
  const {
    loginState,
    cartCount,
    setCartCount,
    setActivityPermissionMeta,
    setSelectedAddressKey,
    selectedAddressKey,
  } =
    useContext(AppContext);
  const [categoryList, setCategoryList] = useState<any>();
  const [activityDetail, setActivityDetail] = useState<any>();
  const [bundleList, setBundleList] = useState<Bundle[]>([]);
  const [currentBundle, setCurrentBundle] = useState<Bundle | undefined>();
  const [keyword, setKeyword] = useState<string>("");
  const [queryKey, setQuerykey] = useState<{
    value: string;
    trigger: "init" | "cache" | "search";
  }>({ value: "", trigger: "cache" });
  const [filterDataReady, setFilterDataReady] = useState<boolean>(false);
  const [productList, setProductList] = useState<any[]>([]);
  const [activityMsg, setActivityMsg] = useState<string>("");
  const [filteredCategories, setFilteredCategories] = useState<any>({
    activeTab: "activity",
    filteredMap: new Map(),
    pageConf: { pageNum: 1, pageSize: 15 },
  });
  const [loading, setLoading] = React.useState<boolean>(true);
  const [loadingActivity, setLoadingActivity] = React.useState<boolean>(true);
  const [activityDescDrawer, setActivityDescDrawer] = useState<boolean>(false);

  // 获取页面滚动位置和目标 div 位置
  const [scrollPosition, setScrollPosition] = useState(0);
  const targetDivRef = useRef<HTMLDivElement | null>(null);
  const [showFixedPrice, setShowFixedPrice] = useState<boolean>(true);
  const [isTargetDivFixed, setIsTargetDivFixed] = useState(false);
  const [isFilterOnTop, setisFilterOnTop] = useState(false);
  const [changeTabType, setChangeTabType] = useState(false);
  const [clearAllSearch, setClearAllSearch] = useState(false);
  const [clearCurrentSearch, setClearCurrentSearch] = useState(false);
  const [searchAllProducts, setSearchAllProducts] = useState(false);
  const [isSearchProductsType, setIsSearchProductsType] = useState(false);
  const [analaticData] = useState<any>({});
  const searchParams = new URLSearchParams(location.search);
  const bundleId = searchParams.get("bundleId");  
  const currentST = searchParams.get("currentST");

  const isAddOnPurchase = activityDetail?.activityBasicType === ADD_ON_PURCHASE_TYPE;
  const addOnIdentity = [activityId, loginState.status, loginState.token, selectedAddressKey].join("|");
  const fetchAddOnPurchaseProducts = useAddOnPurchaseRequest(addOnIdentity);
  const addOnListIdentity = useRef("");

  useEffect(() => {
    if (loginState?.status !== "login") {
      return;
    }
    if (!currentST) {
      return;
    }
    const nextAddressKey = getInitialSelectedAddressKey(loginState, currentST);
    if (!nextAddressKey) {
      return;
    }
    if (localStorage.getItem("selectedAddressKey") === nextAddressKey) {
      setSelectedAddressKey(nextAddressKey);
    } else {
      localStorage.setItem("selectedAddressKey", nextAddressKey);
      setSelectedAddressKey(nextAddressKey);
    }
    const nextSearchParams = new URLSearchParams(location.search);
    nextSearchParams.delete("currentST");
    navigate(
      {
        pathname: location.pathname,
        search: nextSearchParams.toString()
          ? `?${nextSearchParams.toString()}`
          : "",
      },
      { replace: true }
    );
  }, [
    currentST,
    location.pathname,
    location.search,
    loginState,
    navigate,
    setSelectedAddressKey,
  ]);

  const userInfo = loginState?.user?.user;
  useEffect(() => {
    if (!isMobile()) {
      const searchParams = new URLSearchParams(location.search);
      navigate(`/${activityId}?${searchParams.toString()}`, { replace: true });
      return;
    }
    (window as any).currentCampaignId = activityId;
    console.log("Activity component mounted", loginState, activityId);
    const loginStatus = loginState?.status;
    if ((loginStatus === "login" || loginStatus === "failed") && activityId) {
      localStorage.setItem("currentCampaignId", activityId);
      getActivityDetail();
    }
    if (loginStatus === "login" && activityId) {
      const selectedST = getSelectedSTObj(loginState);
      getCartCount(activityId, (count: number) => {
        setCartCount(count);
      }, selectedST?.accountNumber);
    }
  }, [loginState, activityId]);
  useEffect(() => {
    console.log("Activity component mounted", loginState, activityId);
    const loginStatus = loginState?.status;
    if (
      (loginStatus === "login" ||
        loginStatus === "failed" ||
        !loadingActivity) &&
      filterDataReady &&
      activityId
    ) {
      console.log("activeTab", filteredCategories.activeTab);
      getCategoryList(filteredCategories.activeTab);
      getBundleList();
    }
  }, [
    loginState,
    loadingActivity,
    activityId,
    filterDataReady,
    filteredCategories.activeTab,
  ]);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const filter = searchParams.get("filter");
    if (filter) {
      // filter object structure: {pageNum: 1, pageSize: 15, tab: 'activity', categories: ['1#2', '3#4'], queryKey: 'keyword'}
      console.log("filter", filter);

      const filterObj = JSON.parse(decodeURIComponent(filter));
      const { pageNum, pageSize, tab, categories, queryKey } = filterObj;
      if (queryKey) {
        setKeyword(queryKey);
        setQuerykey({ value: queryKey, trigger: "init" });
      }
      const pageConf = { pageNum: pageNum || 1, pageSize: pageSize || 15 };
      const categoriesMap = new Map();
      categories?.forEach((category: string) => {
        const [pName, sName] = category.split(":");
        if (sName) {
          let pCatMap = categoriesMap.get(pName) || new Map();
          pCatMap.set(sName, { categoryName: sName, pName });
          categoriesMap.set(pName, pCatMap);
        } else {
          categoriesMap.set(pName, "all");
        }
      });
      console.log("categoriesMap", categoriesMap);
      // const aaPageDetail = {
      //   type: "campaigns",
      //   name: `campaigns:${tab}`,
      // };
      // pageDetailsDataPush(aaPageDetail);
      setFilteredCategories({
        activeTab: tab,
        filteredMap: categoriesMap,
        pageConf,
      });
    }
    setFilterDataReady(true);
    console.log("Activity component mounted setLoadReady(true)");
  }, []);

  function getScrollPosition() {
    const scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    return scrollTop;
  }
  // 监听页面滚动事件
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(getScrollPosition());
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const setProductsWrapperMarginTop = (marginTop: any) => {
    let productsWrapper: any =
      document.getElementsByClassName("productsWrapper");
    productsWrapper[0].style.marginTop = marginTop;
  };

  const isScroll = (targetDivRef: any) => {
    if (scrollPosition >= getBannerHeight()) {
      targetDivRef.current.style.position = "fixed";
      targetDivRef.current.style.top = "50px";
      targetDivRef.current.style.width = "100%";
      let productsWrapper: any =
        document.getElementsByClassName("productsWrapper");
      let marginTop = 0;
      if (isSearchProductsType) {
        marginTop = getAllFilterWrapperHeight() + 43;
        setIsSearchProductsType(false);
        console.log("marginTop111" + marginTop);
      } else if (searchAllProducts) {
        marginTop = 0;
        setSearchAllProducts(false);
        console.log("marginTop222" + marginTop);
      }
      // else if (isFilterOnTop) {
      //   marginTop = 0;
      //   setisFilterOnTop(false);
      //   console.log("marginTop444 " + marginTop);
      // }
      else {
        marginTop = getAllFilterWrapperHeight() + 80;
        console.log("marginTop333" + marginTop);
      }

      productsWrapper[0].style.marginTop = marginTop + "px";
      setShowFixedPrice(false);
      setIsTargetDivFixed(true);
    } else if (searchAllProducts) {
      setSearchAllProducts(false);
    } else if (changeTabType) {
      setChangeTabType(false);
    } else if (clearAllSearch) {
      setClearAllSearch(false);
    } else if (clearCurrentSearch) {
      setClearCurrentSearch(false);
    } else {
      console.log(
        "===================================isFilterOnTop",
        isFilterOnTop
      );
      targetDivRef.current.style.position = "static";
      setShowFixedPrice(true);
      setIsTargetDivFixed(false);
      let productsWrapper: any =
        document.getElementsByClassName("productsWrapper");
      productsWrapper[0].style.marginTop = "0px";
    }
  };

  useEffect(() => {
    if (targetDivRef.current) {
      isScroll(targetDivRef);
    }
  }, [scrollPosition, targetDivRef.current]);

  useEffect(() => {
    if (
      loginState?.status !== "idle" &&
      activityId &&
      loadReady &&
      activityDetail
    ) {
      console.log(
        "getProductList",
        loginState,
        loadReady,
        activityId,
        queryKey,
        filteredCategories
      );
      getProductList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginState, activityDetail, loadReady, activityId, filteredCategories,
    isAddOnPurchase ? selectedAddressKey : undefined]);
  useEffect(() => {
    console.log("loadMoreNode.current", loadMoreNode?.current);
    if (loadMoreNode.current) {
      const observer = new IntersectionObserver(
        (entries) => {
          let item = entries[0];
          if (item.isIntersecting) {
            // observer.unobserve(loadMoreNode.current);
            console.log("isIntersecting", item);
            if (hasNextPage) {
              setFilteredCategories((pre: any) => {
                return {
                  ...pre,
                  pageConf: {
                    pageNum: pre.pageConf.pageNum + 1,
                    pageSize: pre.pageConf.pageSize,
                  },
                };
              });
              return;
            }
            if (loadMoreNode?.current) {
              observer.unobserve(loadMoreNode.current);
            }
          }
        },
        { threshold: 1 }
      );
      observer.observe(loadMoreNode.current);
      return () => {
        if (!loadMoreNode.current) return;
        observer?.unobserve(loadMoreNode.current);
        observer.disconnect();
      };
    }
  }, [hasNextPage]);

  useEffect(() => {
    if (changeTabType) {
      setProductsWrapperMarginTop("0px");
      window.scrollTo(0, getAllFilterWrapperHeight() + 40);
    }

    if (clearAllSearch) {
      setProductsWrapperMarginTop("0px");
      window.scrollTo(0, 126);
    }

    if (clearCurrentSearch) {
      setProductsWrapperMarginTop("0px");
      console.log("getAllFilterWrapperHeight()", getAllFilterWrapperHeight());
      if (getAllFilterWrapperHeight() > getBannerWrappersHeight()) {
        console.log("clearCurrentSearch---111");
        window.scrollTo(0, 0);
      } else if (!(filteredCategories.filteredMap.size > 0 || queryKey.value)) {
        window.scrollTo(0, getAllFilterWrapperHeight() + 20);
      } else {
        console.log("clearCurrentSearch---333");
        window.scrollTo(
          0,
          getAllFilterWrapperHeight() - getFilterWrapper2Height()
        );
      }
    }

    if (searchAllProducts) {
      console.log("searchAllProducts--查询search区域的放大镜");
      if (targetDivRef.current) {
        targetDivRef.current.style.position = "static";
        setProductsWrapperMarginTop("0px");
        window.scrollTo(0, 0);

        targetDivRef.current.style.position = "fixed";
        targetDivRef.current.style.top = "50px";
        targetDivRef.current.style.width = "100%";
        console.log(
          "searchAllProducts getAllFilterWrapperHeight()",
          getAllFilterWrapperHeight()
        );
        let marginTop = getAllFilterWrapperHeight();
        console.log("searchAllProducts marginTop", marginTop);
        window.scrollTo(0, 88);
      }
    }
  }, [filteredCategories]);

  useEffect(() => {
    if (activityDescDrawer || filterDrawer) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
      window.scrollTo(0, document.body.scrollTop + 1);
    }
  }, [activityDescDrawer, filterDrawer]);
  const getBundleList = async () => {
    if (activityDetail?.activityBasicType !== "bundle_promotion") return;
    try {
      const selectedST = getSelectedSTObj(loginState);
      const bundleListRequestUrl = selectedST?.accountNumber
        ? `${activityBundleListUrl}?activityId=${activityId}&customerStNumber=${selectedST.accountNumber}`
        : `${activityBundleListUrl}?activityId=${activityId}`;
      const resp = await axios(
        bundleListRequestUrl,
        {
          method: "GET",
          headers: {
            Authorization: getAuthToken(),
            "Content-Type": "application/json",
          },
        }
      );
      if (resp.status === 200) {
        const respData = resp.data;
        console.log("getBundleList respData", respData);
        if (respData.status === "success") {
          const buzData = respData.data;
          console.log("getBundleList buzData", buzData);
          setBundleList(buzData);
          buzData[0].checked = true;
          setCurrentBundle(bundleId ? buzData.find((item: any) => item.id === parseInt(bundleId)) || buzData[0] : buzData[0]);
        }
        setLoading(false);
        setLoadReady(true);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleFilter = (filteredMap: any) => {
    setFilteredCategories({
      ...filteredCategories,
      filteredMap: filteredMap,
      pageConf: { pageNum: 1, pageSize: filteredCategories.pageConf.pageSize },
    });
    if (filteredMap.size > 0) {
      analaticData.trigger = "filter";
    } else {
      analaticData.trigger = "reset";
    }
    setFilterDrawer(false);
    setIsSearchProductsType(true);

    // 更新搜索或查询条件相关的状态变量
    setTimeout(() => {
      setisFilterOnTop(false);
      scrollToTargetDiv();
    }, 500); // 延时 500 毫秒
  };

  const getBannerHeight = () => {
    let bannerReminde = document.getElementsByClassName(
      "banner-reminder"
    ) as HTMLCollectionOf<HTMLElement>;
    let bannerWrappers = document.getElementsByClassName(
      "bannerWrapper"
    ) as HTMLCollectionOf<HTMLElement>;
    let bannerRemindeHeight = 0;
    let bannerWrappersHeight = 0;

    if (bannerReminde && bannerReminde.length > 0) {
      bannerRemindeHeight = bannerReminde[0].offsetHeight;
    }
    if (bannerWrappers && bannerWrappers.length > 0) {
      bannerWrappersHeight = bannerWrappers[0].offsetHeight;
    }

    return bannerRemindeHeight + bannerWrappersHeight;
  };
  const getBannerWrappersHeight = () => {
    let bannerWrappers = document.getElementsByClassName(
      "bannerWrapper"
    ) as HTMLCollectionOf<HTMLElement>;
    let bannerWrappersHeight = 0;

    if (bannerWrappers && bannerWrappers.length > 0) {
      bannerWrappersHeight = bannerWrappers[0].offsetHeight;
    }

    return bannerWrappersHeight;
  };

  const getFixedPriceHeight = () => {
    let fixedPriceWrapper = document.getElementsByClassName(
      "tabInfoWrapper"
    ) as HTMLCollectionOf<HTMLElement>;
    let fixedPriceWrapperHeight = 0;

    if (fixedPriceWrapper && fixedPriceWrapper.length > 0) {
      fixedPriceWrapperHeight = fixedPriceWrapper[0].offsetHeight;
    }

    console.log("fixedPriceWrapperHeight", fixedPriceWrapperHeight);
    return fixedPriceWrapperHeight;
  };

  const getAllFilterWrapperHeight = () => {
    let allFilterWrapper = document.getElementsByClassName(
      "allFilterWrapper"
    ) as HTMLCollectionOf<HTMLElement>;
    let allFilterWrapperHeight = 0;

    if (allFilterWrapper && allFilterWrapper.length > 0) {
      allFilterWrapperHeight = allFilterWrapper[0].offsetHeight;
    }

    console.log("allFilterWrapperHeight", allFilterWrapperHeight);
    return allFilterWrapperHeight;
  };

  const getFilterWrapper2Height = () => {
    let filterWrapper2 = document.getElementsByClassName(
      "filterWrapper2"
    ) as HTMLCollectionOf<HTMLElement>;
    let filterWrapper2Height = 0;

    if (filterWrapper2 && filterWrapper2.length > 0) {
      filterWrapper2Height = filterWrapper2[0].offsetHeight;
    }

    console.log("filterWrapper2Height", filterWrapper2Height);
    return filterWrapper2Height;
  };

  // 滚动到目标 div 的顶部
  const scrollToTargetDiv = () => {
    if (targetDivRef.current) {
      targetDivRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      let scrollByHeight = getBannerHeight();
      console.log("scrollToTargetDiv scrollByHeight", scrollByHeight);

      window.scrollBy(0, scrollByHeight + getFixedPriceHeight() + 50); // 向下滚动像素
    }
  };

  const resetActivityRequestState = () => {
    setActivityMsg("");
    setActivityDetail(undefined);
    setLoadingActivity(true);
    setActivityPermissionMeta({
      activityId,
      customerDataType: undefined,
    });
  };

  const getActivityDetail = async () => {
    try {
      resetActivityRequestState();
      const selectedST = getSelectedSTObj(loginState);
      const activityDetailRequestUrl = selectedST?.accountNumber
        ? `${activityDetailUrl}/${activityId}?customerStNumber=${selectedST.accountNumber}`
        : `${activityDetailUrl}/${activityId}`;
      const resp = await axios(activityDetailRequestUrl, {
        method: "GET",
        headers: {
          Authorization: getAuthToken(),
          "Content-Type": "application/json",
        },
      });
      console.log("resp", resp);
      if (resp.status === 200) {
        const respData = resp.data;
        console.log("getActivityDetail respData", respData);
        if (respData.status === "success") {
          const buzData = respData.data;
          console.log("getActivityDetail buzData", buzData);
          setActivityDetail(buzData);
          localStorage.setItem(
            "activityDetail",
            JSON.stringify(buildActivityCartCache(buzData))
          );
          setActivityPermissionMeta({
            activityId,
            customerDataType: buzData?.customerDataType,
          });
          setLoadingActivity(false);
          if (
            buzData.activityBasicType !== "low_exchange" &&
            filteredCategories.activeTab === "exchange"
          ) {
            setFilteredCategories({
              activeTab: "activity",
              filteredMap: new Map(),
            });
          }
        } else {
          console.log("getActivityDetail failed");
          setActivityMsg(respData.status);
          setLoadingActivity(false);
        }
      }      const aaPageDetail = {
        type: "campaigns",
        name: `campaigns:${filteredCategories.activeTab}`,
      };
      pageDetailsDataPush(aaPageDetail);
      console.log("resp", resp);
    } catch (err) {
      console.log(err);
      setLoadingActivity(false);
    }
  };
  const getCategoryList = async (type: string) => {
    if (activityDetail?.activityBasicType === "bundle_promotion") return;
    try {
      const selectedST = getSelectedSTObj(loginState);
      const categoryListRequestUrl = selectedST?.accountNumber
        ? `${activityCategoryUrl}?activityId=${activityId}&type=${type}&customerStNumber=${selectedST.accountNumber}`
        : `${activityCategoryUrl}?activityId=${activityId}&type=${type}`;
      const resp = await axios(
        categoryListRequestUrl,
        {
          method: "GET",
          headers: {
            Authorization: getAuthToken(),
            "Content-Type": "application/json",
          },
        }
      );
      if (resp.status === 200) {
        const respData = resp.data;
        console.log("getCategoryList respData", respData);
        if (respData.status === "success") {
          const buzData = respData.data;
          console.log("getCategoryList buzData", buzData);
          buzData.forEach((category: any) => {
            category.subCategoryList.unshift({
              id: "all",
              categoryName: "全部",
            });
          });
          setCategoryList(buzData);
          setLoadReady(true);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleAnalaticSearch = (type: number, searchText: string, analaticData: any) => {
    if (analaticData.step == 1) {
      const searchPayload: any = {
        eventType: type ? "search:successful" : "search:failure",
        searchType: "sub search:marketing",
        keyword: searchText,
        unique: analaticData.unique,
      };
      if (Object.keys(analaticData.filters).length > 0) {
        searchPayload.filters = analaticData.filters;
      }
      subSearchDataPush(searchPayload);
      analaticData.step = 2;
    }
  };
  const getProductList = async () => {
    if (isAddOnPurchase && addOnListIdentity.current !== addOnIdentity) {
      const customerChanged = addOnListIdentity.current !== "";
      addOnListIdentity.current = addOnIdentity;
      setProductList([]);
      setHasNextPage(false);
      if (customerChanged && filteredCategories.pageConf.pageNum !== 1) {
        setFilteredCategories((previous: typeof filteredCategories) => ({
          ...previous, pageConf: { ...previous.pageConf, pageNum: 1 },
        }));
        return;
      }
    }

    const { categories, memoCat } = getFilteredCategories(
      filteredCategories.filteredMap,
      categoryList
    );
    const selectedST = getSelectedSTObj(loginState);
    const pageConf = filteredCategories.pageConf;
    const reqBody = {
      activityId,
      type: filteredCategories.activeTab,
      categories,
      queryKey: queryKey.value,
      ...pageConf,
      shipTo: selectedST?.accountNumber,
    };
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete("refresh");
    searchParams.set(
      "filter",
      JSON.stringify({
        ...pageConf,
        tab: filteredCategories.activeTab,
        categories: memoCat,
        queryKey: queryKey.value,
      })
    );
    const unique = getUniqueness(reqBody.keyword);
    analaticData.unique = unique;
    const filters = { category: categories }
    analaticData.filters = filters
    if (!pageConf?.pageNum || pageConf?.pageNum == 1) {
      if (analaticData.trigger === "search" && reqBody.queryKey) {
        analaticData.step = 1;
        subSearchDataPush({
          eventType: "search:submitted",
          searchType: "sub search:marketing",
          keyword: reqBody.queryKey,
          unique
        })
      }
      if (analaticData.trigger === "filter") {
        analaticData.step = 1;
        subSearchDataPush({
          eventType: "search:filtered",
          searchType: 'sub search:marketing',
          unique,
          filters
        })
      }
      if (analaticData.trigger === "reset") {
        analaticData.step = 1;
        subSearchDataPush({
          eventType: "search:resetFilters",
          searchType: 'sub search:marketing',
          keyword: reqBody.queryKey,
          unique,
          filters
        })
      }
    }
    navigate(`?${searchParams.toString()}`, { replace: true });
    if (pageConf.pageNum === 1) {
      setLoading(true);
    }
    console.log("getProductList reqBody", reqBody, loginState?.token);
    if (isAddOnPurchase) {
      if (pageConf.pageNum === 1) setProductList([]);
      setHasNextPage(false);
    }
    try {
      const requestConfig = {
        method: "POST",
        headers: {
          Authorization: getAuthToken(),
          "Content-Type": "application/json",
        },
        data: reqBody,
      };
      const resp = isAddOnPurchase
        ? await fetchAddOnPurchaseProducts(reqBody, requestConfig.headers)
        : await axios(activityProductsUrl, requestConfig);
      if (!resp) return;
      if (resp.status === 200) {
        const respData = resp.data;
        console.log("getProductList respData", respData);
        if (respData.status === "success") {
          const buzData = respData.data;
          console.log("getProductList buzData", buzData);
          const { pageNum, pageTotal } = buzData;
          if (pageNum === 1) {
            setProductList(buzData.data || []);
          } else {
            setProductList((pre) => [...pre, ...(buzData.data || [])]);
          }
          setHasNextPage(pageNum < pageTotal);
          if (queryKey.trigger === "search") {
            if (buzData.total > 0) {
              logOperation({
                opUser: userInfo?.userId || getAAId(),
                opTarget: "Search_Product",
                opTargetId:
                  memoCat.length > 0
                    ? JSON.stringify({
                      categories: memoCat,
                      queryKey: queryKey.value,
                    })
                    : queryKey.value,
                opContent:
                  filteredCategories.activeTab === "activity"
                    ? "Activity_Detail_Results"
                    : "Exchange_Detail_Results",
              });
            } else {
              logOperation({
                opUser: userInfo?.userId || getAAId(),
                opTarget: "Search_Product",
                opTargetId:
                  memoCat.length > 0
                    ? JSON.stringify({
                      categories: memoCat,
                      queryKey: queryKey.value,
                    })
                    : queryKey.value,
                opContent:
                  filteredCategories.activeTab === "activity"
                    ? "Activity_Detail_NoResults"
                    : "Exchange_Detail_NoResults",
              });
            }
          }
          if (reqBody.pageNum == 1) {
            if (buzData.total > 0) {
              handleAnalaticSearch(1, reqBody.queryKey, analaticData)
            } else {
              handleAnalaticSearch(0, reqBody.queryKey, analaticData)
            }
          }
          queryKey.trigger = "cache";
        }
      }
      setLoading(false);
    } catch (err) {
      if (isAddOnPurchase) message.error(ADD_ON_PURCHASE_MESSAGES.queryFailed);
      console.log(err);
      setLoading(false);
    }
  };

  const toggleDrawer = (e: any) => {
    setFilterDrawer(!filterDrawer);
    console.log("toggleDrawer isTargetDivFixed", isTargetDivFixed);
    setisFilterOnTop(isTargetDivFixed);
    setTimeout(() => {
      if (isTargetDivFixed && filterDrawer) {
        if (targetDivRef.current) {
          targetDivRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          let scrollByHeight = getBannerHeight();
          window.scrollBy(0, scrollByHeight + getFixedPriceHeight() + 80); // 向下滚动像素
        }
      }
    }, 500); // 延时 500 毫秒
  };

  console.log("cartCount", cartCount);
  const onTabChange = (tab: string) => {
    if (filteredCategories.activeTab !== tab) {
      setFilteredCategories({
        activeTab: tab,
        filteredMap: new Map(),
        pageConf: {
          pageNum: 1,
          pageSize: filteredCategories.pageConf.pageSize,
        },
      });
      const aaPageDetail = {
        type: "campaigns",
        name: `campaigns:${tab}`,
      };
      pageDetailsDataPush(aaPageDetail);
      getCategoryList(tab);
      logOperation({
        opUser: userInfo?.userId || getAAId(),
        opTarget: "Exchange_Promo_Tap",
        opTargetId: tab,
        opContent: "Exchange_Promo_Tap",
      });

      if (isTargetDivFixed) {
        setChangeTabType(true);
      }
    }
  };
  const cartTitle = activityDetail?.activityBasicType === "bundle_promotion" ? "已选套装" : "已选产品"

  if (activityMsg) {
    return (
      <>
        <MHeader title={"组合购专区"} />
        <div
          className=""
          style={{
            height: "calc(100vh - 270px)",
            textAlign: "center",
            fontSize: "20px",
          }}
        >
          <Exceptions status={activityMsg}></Exceptions>
        </div>
        <MFooter activityId={activityId} cartTitle={cartTitle} />
      </>
    );
  }
  if (
    loadingActivity ||
    (activityDetail?.activityBasicType !== "bundle_promotion" && !loadReady)
  ) {
    return <Loading />;
  }
  const bannerImg = activityDetail?.images?.find(
    (imgItem: any) => imgItem.type === "mobility_detail"
  );

  return (
    <>
      <MHeader title={"组合购专区"} />
      <div className="mobilePageBody mActivityPageWrapper">
        {/* <div className="banner-reminder reminderWrapper">
          <div className="marquee">
            <label className="reminder-info">{"温馨提醒 "}</label>
            <span className="reminder-wording">
              {
                "该促销优惠仅限在当前页面加购产品才可享受，进入产品详情页或其他页面无法享受。"
              }
            </span>
          </div>
        </div> */}
        <div className="bannerWrapper">
          <div className="bannerImgWrapper">
            <img src={bannerImg?.imageUrl || ""} alt="banner" />
          </div>
          <div className="floatWrapper ">
            <div className="contentWrapper">
              <div>
                <h1
                  className="title"
                  style={{ color: activityDetail?.fontColor || "#fff" }}
                >
                  {activityDetail?.title}
                </h1>
                <div className="activityInfo">
                  <div
                    className="timeRanger"
                    style={{ color: activityDetail?.fontColor || "#fff" }}
                  >
                    <span>{formatDate(activityDetail?.startTime)}</span> -{" "}
                    <span>{formatDate(activityDetail?.endTime)}</span>
                  </div>
                </div>
              </div>
              <div className="bottomBlock">
                <Button
                  className="mprimaryBtn"
                  onClick={() => {
                    logOperation({
                      opUser: userInfo?.userId || getAAId(),
                      opTarget: "Activity_Specification",
                      opTargetId: "",
                      opContent: "Activity_Specification",
                    });
                    setActivityDescDrawer(true);
                  }}
                >
                  活动细则
                </Button>
              </div>
            </div>
          </div>
        </div>
        {loading && <Loading />}
        <>
          {activityDetail.activityBasicType === "bundle_promotion" ? (
            <MBundleList
              activityId={activityId}
              previewFlag={activityDetail.previewFlag}
              bundles={bundleList}
              currentBundle={currentBundle}
              setCurrentBundle={(bundle: any) => {
                setCurrentBundle(bundle);
                const queryParams = new URLSearchParams(location.search)
                queryParams.set("bundleId", bundle.id.toString())
                navigate(`${location.pathname}?${queryParams.toString()}`, {replace: true})
              }}
            />
          ) : (
            <>
              {" "}
              <div className="allFilterWrapper" ref={targetDivRef}>
                <div className="filterWrapper1">
                  <div className="tabsInner">
                    <div
                      className={`tabItem ${filteredCategories.activeTab === "activity"
                        ? "active"
                        : ""
                        }`}
                      onClick={() => {
                        onTabChange("activity");
                      }}
                    >
                      <img
                        alt="activity"
                        src={
                          filteredCategories.activeTab === "activity"
                            ? activeActivityIcon
                            : activityIcon
                        }
                      ></img>
                      <span>{activityDetail?.activityTypeName}</span>
                    </div>
                    {activityDetail?.activityBasicType === "low_exchange" && (
                      <>
                        <div className="vdivider"></div>
                        <div
                          className={`tabItem exchange ${filteredCategories.activeTab === "exchange"
                            ? "active"
                            : ""
                            }`}
                          onClick={() => {
                            console.log("tab clicked");
                            onTabChange("exchange");
                          }}
                        >
                          <img
                            alt="exchange"
                            src={
                              filteredCategories.activeTab === "exchange"
                                ? activeExchangeIcon
                                : exchangeIcon
                            }
                          ></img>
                          <span>
                            {activityDetail?.exchangeTypeName || "换购"}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                  {showFixedPrice ? (
                    <div className="tabInfoWrapper">
                      {filteredCategories.activeTab === "activity"
                        ? activityDetail?.activityTypeDescription
                        : activityDetail?.exchangeTypeDescription}
                    </div>
                  ) : (
                    <div className="fixedPricelabel"></div>
                  )}
                </div>
                <div className="filterWrapper2">
                  <div className="searchFilterWrapper">
                    {!!categoryList?.length && (
                      <button
                        className={`categoryMenu ${filterDrawer ? "active" : ""
                          }`}
                        onClick={(e) => {
                          toggleDrawer(e);
                        }}
                      >
                        <span className="menuLabel">产品分类</span>
                        <span className={"arrowDownwardIcon"}></span>
                      </button>
                    )}
                    <div className="searchWrapper">
                      <span className="searchInput">
                        <span className="icon">
                          <img
                            src={searchIcon}
                            alt="search"
                            onClick={() => {
                              setQuerykey({
                                value: keyword,
                                trigger: "search",
                              });
                              setFilteredCategories({
                                ...filteredCategories,
                                pageConf: {
                                  pageNum: 1,
                                  pageSize:
                                    filteredCategories.pageConf.pageSize,
                                },
                              });

                              if (isTargetDivFixed) {
                                setSearchAllProducts(true);
                              }
                            }}
                          ></img>
                        </span>
                        <input
                          className="input"
                          placeholder="搜索全部活动产品"
                          value={keyword}
                          onChange={(e) => {
                            setKeyword(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              analaticData.trigger = "search";
                              setQuerykey({
                                value: keyword,
                                trigger: "search",
                              });
                              setFilteredCategories({
                                ...filteredCategories,
                                pageConf: {
                                  pageNum: 1,
                                  pageSize:
                                    filteredCategories.pageConf.pageSize,
                                },
                              });

                              if (isTargetDivFixed) {
                                setSearchAllProducts(true);
                              }
                            }
                          }}
                        ></input>
                      </span>
                    </div>
                  </div>
                  {(filteredCategories.filteredMap.size > 0 ||
                    queryKey.value) && (
                      <div className="filteredInfoWrapper">
                        <Space>
                          {Array.from(filteredCategories.filteredMap)?.map(
                            ([key, filteredCat]: any) => {
                              console.log("filteredCat", filteredCat);
                              // key is the category id, filteredCat is the category name
                              if (typeof filteredCat === "string") {
                                return (
                                  <span
                                    key={key}
                                    className="deletableBtn"
                                    onClick={() => {
                                      console.log(
                                        "filteredCat clicked",
                                        filteredCat
                                      );
                                      analaticData.trigger = "reset";
                                      const filterMap =
                                        filteredCategories.filteredMap;
                                      filterMap.delete(key);
                                      setFilteredCategories({
                                        ...filteredCategories,
                                        filteredMap: new Map(filterMap),
                                      });

                                      if (isTargetDivFixed) {
                                        setClearCurrentSearch(true);
                                      }
                                    }}
                                  >
                                    {key}
                                    <span className="delIcon">
                                      <img src={delIcon}></img>
                                    </span>
                                  </span>
                                );
                              } else {
                                return Array.from(filteredCat)?.map(
                                  ([subKey, subCat]: any) => {
                                    return (
                                      <span
                                        key={subCat.pName + subKey}
                                        className="deletableBtn"
                                        onClick={() => {
                                          console.log(
                                            "filteredCat clicked",
                                            subCat
                                          );
                                          const filterMap =
                                            filteredCategories.filteredMap;
                                          let pCatMap = filterMap.get(key);
                                          pCatMap.delete(subKey);
                                          if (pCatMap.size === 0) {
                                            filterMap.delete(key);
                                          } else {
                                            filterMap.set(key, pCatMap);
                                          }
                                          setFilteredCategories({
                                            ...filteredCategories,
                                            filteredMap: new Map(filterMap),
                                          });

                                          if (isTargetDivFixed) {
                                            setClearCurrentSearch(true);
                                          }
                                        }}
                                      >
                                        {subCat.categoryName}
                                        <span className="delIcon">
                                          <img src={delIcon}></img>
                                        </span>
                                      </span>
                                    );
                                  }
                                );
                              }
                            }
                          )}
                          {queryKey.value ? (
                            <span
                              className="deletableBtn"
                              onClick={() => {
                                analaticData.trigger = "reset";
                                setKeyword("");
                                setQuerykey({ value: "", trigger: "cache" });
                                setFilteredCategories({
                                  ...filteredCategories,
                                  pageConf: {
                                    pageNum: 1,
                                    pageSize:
                                      filteredCategories.pageConf.pageSize,
                                  },
                                });

                                if (isTargetDivFixed) {
                                  setClearCurrentSearch(true);
                                }
                              }}
                            >
                              关键字：{queryKey.value}
                              <span className="delIcon">
                                <img src={delIcon} alt=""></img>
                              </span>
                            </span>
                          ) : null}
                          {queryKey.value ||
                            filteredCategories.filteredMap.size > 0 ? (
                            <span
                              className="delAllBtn"
                              onClick={() => {
                                analaticData.trigger = "reset";
                                setFilteredCategories({
                                  activeTab: filteredCategories.activeTab,
                                  filteredMap: new Map(),
                                  pageConf: {
                                    pageNum: 1,
                                    pageSize:
                                      filteredCategories.pageConf.pageSize,
                                  },
                                });
                                setKeyword("");
                                setQuerykey({ value: "", trigger: "cache" });

                                if (isTargetDivFixed) {
                                  setClearAllSearch(true);
                                }
                              }}
                            >
                              清除全部
                            </span>
                          ) : null}
                        </Space>
                      </div>
                    )}
                </div>
              </div>
              <div className="productsWrapper">
                {!productList.length && !loading && (
                  <div className="noDataWrapper">
                    抱歉！未找到符合您需求的产品。
                  </div>
                )}
                {isAddOnPurchase ? (
                  <MAddOnPurchaseProductList activityId={activityId} loginState={loginState}
                    products={productList} previewFlag={activityDetail?.previewFlag} />
                ) : (
                  <div className="productList">
                  {productList?.map((product: any) => {
                    return (
                      <MProductCard
                        activityId={activityId}
                        tab={filteredCategories.activeTab}
                        loginState={loginState}
                        previewFlag={activityDetail?.previewFlag}
                        key={(product.category || "") + product.sku}
                        product={product}
                      />
                    );
                  })}
                </div>
                )}
                {hasNextPage && (
                  <div ref={loadMoreNode}>
                    <LoadingMore />
                  </div>
                )}
              </div>
            </>
          )}
        </>
      </div>
      <MFooter activityId={activityId} cartCount={cartCount} cartTitle={cartTitle} />
      <Drawer
        rootClassName="filterDrawer"
        placement="top"
        open={filterDrawer}
        onClose={toggleDrawer}
      >
        {filterDrawer && (
          <CheckList
            checkDataList={categoryList}
            initialCheckedMap={filteredCategories.filteredMap}
            isTargetDivFixed={isTargetDivFixed}
            targetDivRef={targetDivRef}
            isScroll={isScroll}
            onCancel={toggleDrawer}
            onConfirm={handleFilter}
          />
        )}
      </Drawer>
      <Drawer
        title="活动细则"
        rootClassName="activityDescDrawer"
        open={activityDescDrawer}
        placement="bottom"
        onClose={() => {
          setActivityDescDrawer(false);
        }}
      >
        <div className="activitySpecWrapper">
          <div id="activitySpec" className="pageContentContainer">
            <RichTextContent
              html={activityDetail?.description || "占位测试layout"}
            />
          </div>
        </div>
      </Drawer>
    </>
  );
};

function CheckList(props: any) {
  const {
    checkDataList,
    onConfirm,
    initialCheckedMap,
    isTargetDivFixed,
    targetDivRef,
    isScroll,
  } = props;
  const [filterMap, setFilterMap] = useState<any>(new Map(initialCheckedMap));
  const [checkedItem, setCheckedItem] = useState<any>(null);
  useEffect(() => {
    const checkedParent = checkDataList?.find((item: any) =>
      filterMap.has(item.categoryName)
    );
    if (!checkedParent) {
      setCheckedItem(checkDataList[0]);
    } else {
      setCheckedItem(checkedParent);
    }
  }, [checkDataList]);
  const reset = () => {
    setFilterMap(new Map());
  };
  console.log("hasSubTree, checkedItem", checkedItem);
  return (
    <div className="filterContainer">
      <div className="checkListContainer">
        <ul className={"tree"}>
          {checkDataList &&
            checkDataList.map((filterItem: any) => {
              const isChecked =
                filterItem["categoryName"] === checkedItem?.categoryName;
              return (
                <li
                  key={filterItem["id"]}
                  className={`checkListItem ${isChecked ? "checkedListItem" : ""
                    }`}
                  onClick={() => {
                    setCheckedItem({ ...filterItem });
                  }}
                >
                  <label>{filterItem["categoryName"]}</label>
                </li>
              );
            })}
        </ul>
        {
          <ul className="subTree">
            {checkedItem &&
              checkedItem.subCategoryList?.map((filterItem: any) => {
                let isChecked = false;
                const isParentChecked = filterMap.has(checkedItem.categoryName);
                const tempMap = filterMap.get(checkedItem.categoryName);
                if (
                  isParentChecked &&
                  (tempMap === "all" ||
                    (filterItem.id === "all" &&
                      tempMap.size === checkedItem.subCategoryList.length - 1))
                ) {
                  isChecked = true;
                } else isChecked = tempMap?.has(filterItem.categoryName);
                isChecked = !!isChecked;

                return (
                  <li
                    key={filterItem["id"]}
                    className={`checkListItem ${isChecked ? "checkedListItem" : ""
                      }`}
                    onClick={() => {
                      console.log(
                        "filterItem clicked, isChecked",
                        filterItem,
                        isChecked
                      );
                      if (filterItem.id === "all") {
                        if (isChecked) {
                          filterMap.delete(checkedItem.categoryName);
                        } else {
                          filterMap.set(checkedItem.categoryName, "all");
                        }
                      } else {
                        if (isChecked) {
                          const sCatMap = filterMap.get(
                            checkedItem.categoryName
                          );
                          sCatMap?.delete(filterItem.categoryName);
                          if (sCatMap.size === 0) {
                            filterMap.delete(checkedItem.categoryName);
                          } else {
                            filterMap.set(checkedItem.categoryName, sCatMap);
                          }
                        } else {
                          let sCatMap = filterMap.get(checkedItem.categoryName);
                          if (!sCatMap || typeof sCatMap === "string") {
                            sCatMap = new Map();
                            sCatMap.set(filterItem.categoryName, {
                              categoryName: filterItem.categoryName,
                              pName: checkedItem.categoryName,
                            });
                            filterMap.set(checkedItem.categoryName, sCatMap);
                          }
                          sCatMap.set(filterItem.categoryName, {
                            categoryName: filterItem.categoryName,
                            pName: checkedItem.categoryName,
                          });
                        }
                      }
                      console.log("filterMap", filterMap);
                      setFilterMap(() => {
                        return new Map(filterMap);
                      });
                    }}
                  >
                    <label>{filterItem["categoryName"]}</label>
                  </li>
                );
              })}
          </ul>
        }
      </div>
      <div className="actionsContainer">
        <Button className="resetBtn" onClick={reset}>
          {"重置"}
        </Button>
        <Button
          className="confirmBtn"
          onClick={() => {
            onConfirm(filterMap);
          }}
        >
          确认
        </Button>
      </div>
    </div>
  );
}
export default MActivity;
